import { CatalogOperationModel } from "../../models/operations/catalogOperationModel";
import { Watch } from "vue-property-decorator";
import { CatalogOperationVue } from "./CatalogOperationVue";
import { OperationPropertyModel } from "../../models/operations/operationPropertyModel";
import i18n from "@/i18n";

/**Модель представления операции */
export class DepositOperationVue extends CatalogOperationVue {

  @Watch('modalShow', { immediate: true })
  modalHide(val: boolean) {
    if (val) {
      this.OperationModel.operationStage = null;
    } else {
      this.isUserAccepted = false;
    }
  }

  isUserAccepted: boolean = false;

  async nextStep(): Promise<void> {
    this.validateForm();
    if (this.isUserAccepted) {
      this.OperationModel.Properties.forEach((prop: OperationPropertyModel) => { 
        if (prop.errorText.length > 0) {
          prop.errorText = '';
          prop.loadCheckRules();
        }
      });
      this.modalShow = false;
      this.OperationModel.operationStage = null;
      await this.next();
    } else if (this.isValid && !this.modalShow) {
      this.execLoading = true;
      this.OperationModel = (await this.service.prepare(this.OperationModel) as CatalogOperationModel);
      this.OperationModel._actionState = 0;
      this.modalShow = true;
      this.isUserAccepted = true;
      this.execLoading = false;
    } else if (this.modalShow && !this.isUserAccepted) {
      this.alertService.warning(i18n.t('main.operation.form.depositOpenRules.warningText'), false);
    }
  }

  get confirmText(): string {
    return i18n.t("main.operation.form.depositOpenRules.confirmButton");
  }

  closeAcceptModal(): void {
    this.modalShow = false;
    this.isUserAccepted = false;
    this.OperationModel.operationStage = 0;
  }

  get modalContent(): Array<string> {
    const obj: any = i18n.t('main.operation.form.depositOpenRules.content');
    let res: Array<string> = [];
    Object.keys(obj).forEach((key: string) => {
      if (key)
        res.push(i18n.t('main.operation.form.depositOpenRules.content')[key]);
    });
    return res;
  }

  // /**Инициализация операции */
  // async initOperation(): Promise<void> {
  //   super.initOperation();
  // }

  /**Метод для выполнения после успешного проведения */
  async afterExecute(): Promise<void> {
    this.appStore.setLoading(true);
    this.appStore.setCatalogFlag(true);
    // if (this.OperationModel.IsSuccess) {
    //   this.alertService.success(i18n.t('main.operations.messages.creditSuccess'), false);
    // } else if (this.OperationModel.IsError) {
    //   this.alertService.error(this.OperationModel.ActionStateText, false);
    // } else if (this.OperationModel.IsExecuting) {
    //   this.alertService.warning(this.OperationModel.ActionStateText, false);
    // }
    this.$router.push(`/products?operId=${this.OperationModel.OperationId}`);
  }
}
